module.exports = __webpack_public_path__ + "static/media/light-back-icon.f0374789.svg";